import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Product.css";
import { Helmet } from "react-helmet";

function Products() {
  const [products, setProducts] = useState([]);
  const [activeCard, setActiveCard] = useState(null); // ✅ Track which card is active

  useEffect(() => {
    axios
      .get("https://alphoraback.onrender.com/api/products")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error(err));
  }, []);

  const groupedProducts = products.reduce((acc, product) => {
    if (!acc[product.category]) acc[product.category] = [];
    acc[product.category].push(product);
    return acc;
  }, {});

  const handleCardClick = (id) => {
    setActiveCard(activeCard === id ? null : id); // ✅ toggle active card
  };

  return (
    <>
  <Helmet>
    <title>Alphora | Trusted Medical & Orthopedic Products</title>
    <meta
      name="description"
      content="Alphora offers medical equipment, orthopedic solutions, and mobility aids designed for safety, comfort, and durability."
    />
    <meta
      name="keywords"
      content="medical equipment, orthopedic products, wheelchairs, walkers, commode chairs, Alphora"
    />
    <meta name="author" content="Alphora" />

    {/* Open Graph (for social media previews) */}
    <meta property="og:title" content="Alphora | Medical & Ortho Products" />
    <meta
      property="og:description"
      content="Trusted quality powering medical excellence – explore Alphora’s range of medical and orthopedic solutions."
    />
    <meta property="og:image" content="/images/logo2.png" />
    <meta property="og:url" content="https://yourdomain.com" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
  </Helmet>

    <div className="products">
<h2 className="show">Our Products</h2>
      {Object.keys(groupedProducts).map((category) => (
        <div key={category} className="category-section">
          <h3>{category}</h3>
          <div className="product-grid">
            {groupedProducts[category].map((p) => (
              <div
                className={`card ${activeCard === p._id ? "active" : ""}`}
                key={p._id}
                onClick={() => handleCardClick(p._id)}
              >
                {p.image && (
                  <img
                    src={`https://alphoraback.onrender.com/uploads/${p.image}`}
                    alt={p.name}
                  />
                )}
                <h4>{p.name}</h4>
                <p className="description">{p.disc}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
 </> );
}

export default Products;
